<table mat-table matSort multiTemplateDataRows [dataSource]="dataSource" class="table w-full">
    <ng-container matColumnDef="logo-template" *ngIf="logoTemplate">
        <th mat-header-cell *matHeaderCellDef class="bg-white w-[50px] text-sm normal-case border-b border-iota-outline"></th>

        <td mat-cell *matCellDef="let row" class="w-fit bg-transparent ml-2">
            <ng-container *ngTemplateOutlet="logoTemplate; context: { row: row }"></ng-container>
        </td>
    </ng-container>

    <ng-container *ngFor="let header of tableHeaderAndData?.headers" [matColumnDef]="header.key">
        <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="header.key"
            class="bg-white text-sm normal-case border-b border-iota-outline"
            [ngClass]="{
                'first:!sticky first:!left-0 first:!z-10': firstColumnIsSticky,
                'first:!static': !firstColumnIsSticky,
                '!px-[2px] first:!pl-2': minimalPadding,
                '!py-1': minimalRowPadding
            }"
            [matTooltip]="header?.tooltip"
            [matTooltipDisabled]="!header?.tooltip"
            matTooltipClass="bg-iota-tooltip-bg"
        >
            <span class="mr-1">{{ header.label }}</span>
            <iota-icon *ngIf="!!header?.tooltip" icon="information-circle"></iota-icon>
        </th>

        <td
            mat-cell
            *matCellDef="let row"
            class="bg-transparent"
            [ngClass]="{
                'line-through decoration-2': row?.[header.key]?.crossedOut,
                'font-bold': row?.[header.key]?.bold,
                'first:!sticky first:!left-0 first:!z-10 first:!bg-inherit': firstColumnIsSticky,
                '!px-[2px] first:!pl-2': minimalPadding,
                '!py-1': minimalRowPadding
            }"
        >
            <!-- prefix -->
            <span *ngIf="row?.[header.key]?.data && !row?.[header.key]?.htmlTemplate">{{ row?.[header.key]?.prefix }}</span>

            <!-- Show the data (wrapped with a link if provided) -->
            <span *ngIf="!row?.[header.key]?.htmlTemplate && !row?.[header.key]?.routerLink">{{ row?.[header.key]?.data }}</span>
            <a
                *ngIf="!row?.[header.key]?.htmlTemplate && !!row?.[header.key]?.routerLink"
                class="link link-hover link-primary"
                [routerLink]="row?.[header.key]?.routerLink"
                >{{ row?.[header.key]?.data }}</a
            >

            <!-- optional html template-->
            <span *ngIf="row?.[header.key]?.htmlTemplate" [innerHTML]="row?.[header.key]?.htmlTemplate | safeHtmlBypass"></span>

            <!-- suffix (e.g. a currency) -->
            <span *ngIf="row?.[header.key]?.data && !row?.[header.key]?.htmlTemplate">{{ row?.[header.key]?.suffix }}</span>

            <!-- Custom content, so that components, icons, etc. can be injected in this cell -->
            <ng-container *ngIf="customContentTemplate">
                <ng-container *ngTemplateOutlet="customContentTemplate; context: { row: row, key: header.key }"></ng-container>
            </ng-container>
        </td>
    </ng-container>
    <ng-container matColumnDef="action-buttons" *ngIf="actionButtonsTemplate">
        <th mat-header-cell *matHeaderCellDef class="bg-white text-sm normal-case border-b border-iota-outline"></th>

        <td mat-cell *matCellDef="let row" class="bg-transparent flex justify-end mr-2">
            <ng-container *ngTemplateOutlet="actionButtonsTemplate; context: { row: row }"></ng-container>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="headerKeys"></tr>
    <tr
        mat-row
        [hidden]="loading || rendering"
        (dblclick)="doubleClickActionHandler(row)"
        *matRowDef="let row; columns: headerKeys; let even = even"
        [ngClass]="{
            'bg-white': even || !zebraRows,
            'bg-iota-table-zebra': !even && zebraRows
        }"
    ></tr>
</table>
<div
    class="w-full flex flex-col gap-[1px] items-strech"
    skeleton
    skeletonClasses="h-12 w-full"
    [repeat]="10"
    *ngIf="loading || rendering"
></div>
<div class="mt-2 w-full text-center italic" *ngIf="!(loading || rendering) && tableHeaderAndData?.rows?.length === 0">
    {{ emptyTableText }}
</div>
<mat-paginator
    class="mt-2"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="defaultPageSize"
    (page)="onPage($event)"
    showFirstLastButtons
    *ngIf="allowPagination"
></mat-paginator>
